import axios from 'axios';
import Split from '../split/Split';
import { resolveId } from '../../utils';
import { getUsersQuery } from './queries';
import { buildLoopbackQuery, buildExpressQuery } from './queries/builders';

const getUsersByIds = (ids, fields, queryBuilder) =>
    new Promise((resolve, reject) => {
        const resolvedQueryBuilder = queryBuilder || (Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery);
        const userQuery = getUsersQuery({ ids, fields, queryBuilder: resolvedQueryBuilder });
        const userRequest = axios.get(userQuery);
        userRequest
            .then((userResponse) => {
                // Express returns _id instead of id — normalize so downstream
                // code that relies on user.id works consistently.
                resolve(userResponse.data.map(resolveId));
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUsersByIds;
